import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=0c4a32ae"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./shop.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsRetailerMessage: require('/home/node/app/components/patterns/retailer-message/retailer-message.vue').default,ElementsBannerAnimation: require('/home/node/app/components/elements/banner-animation/banner-animation.vue').default,TemplatesCatalogListing: require('/home/node/app/components/templates/catalog-listing/catalog-listing.vue').default})
